import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useContext } from 'react';
import { noop } from '../utils/fn.js';

const FormattedInputValueContext = createContext(null);
const FormattedInputSetterContext = createContext(noop);
/** Get the current formatted input context. */
function useFormattedInputContext() {
    return useContext(FormattedInputValueContext);
}
/** Get a setter to update the current formatted input context. */
function useSetFormattedInputContext() {
    return useContext(FormattedInputSetterContext);
}
/** Context for registering and passing around the current state of a FormattedInput. */
function FormattedInputContext({ children }) {
    const [ctx, setCtx] = useState(null);
    return (jsx(FormattedInputValueContext.Provider, { value: ctx, children: jsx(FormattedInputSetterContext.Provider, { value: setCtx, children: children }) }));
}
FormattedInputContext.displayName = 'FormattedInputContext';

export { FormattedInputContext, useFormattedInputContext, useSetFormattedInputContext };
//# sourceMappingURL=formatted-input.context.js.map
